import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'expiredCreditsTooltip',
    standalone: true
})
export class ExpiredCreditsTooltipPipe implements PipeTransform {
    transform(value: boolean, licenceCredit: number, sharedCredit: number): string {
        return value ? `${licenceCredit} monthly license credits\r\n${sharedCredit} shared credits` : '';
    }
}
